import React from 'react';
import universal, { UniversalComponent } from 'react-universal-component';
import errorHandler from '../common/service/errorHandler';
import MinimalLoader from '../common/components/presentation/MinimalLoader';
import ThemedErrorMessage from '../common/components/presentation/error/ThemedErrorMessage';
import IThemableComponent from '../common/theme/IThemableComponent';
import { ModelCarClasses } from './components/modelBlock/modelCar/modelCarStyles';
import { VariantCarClasses } from './components/variantBlock/variantCar/variantCarStyles';
import { CatalogScreenClasses } from './components/catalogScreenStyles';
import { TabElementClasses } from './components/tab/tabBar/tabElement/tabElementStyles';
import { ProductVariantsClasses } from './components/containers/productVariants/productVariantsStyles';
import { DisclaimerClasses } from '../common/components/disclaimer/disclaimerStyles';

export interface ICatalogThemableComponents {
  Catalog_Screen: IThemableComponent<CatalogScreenClasses>;
  Catalog_ModelCar: IThemableComponent<ModelCarClasses>;
  Catalog_VariantCar: IThemableComponent<VariantCarClasses>;
  Catalog_TabElement: IThemableComponent<TabElementClasses>;
  Catalog_ProductVariants: IThemableComponent<ProductVariantsClasses>;
  Common_Disclaimer: IThemableComponent<DisclaimerClasses>;
}

const CatalogScreen: UniversalComponent<any> = universal(
  () => import(/* webpackChunkName: "models-screen" */ './components/CatalogScreen'),
  {
    loading: (): JSX.Element => <MinimalLoader />,
    error: (props: { error: Error }) => {
      errorHandler.handleError(props.error);
      return <ThemedErrorMessage fullPage={true} message={'Failed loading models screen.'} error={props.error} />;
    },
  },
);

export default CatalogScreen;
